import React from 'react'
import { history } from '../store'
import { connect } from 'react-redux'
import FaultsAnalysisModal, {
  downloadFaultAnalysisExcel,
  downloadFaultAnalysisPDF,
} from './FaultsAnalysisModal'

class FaultsByCustomerList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { analysisCustomer: null }

    this.handleDownloadExcel = this.handleDownloadExcel.bind(this)
    this.handleDownloadPDF = this.handleDownloadPDF.bind(this)
    this.openAnalysis = this.openAnalysis.bind(this)
    this.closeAnalysis = this.closeAnalysis.bind(this)
  }

  goTo(Serial, e) {
    history.push(`/machines/${Serial}`)
  }

  handleDownloadExcel(customer) {
    downloadFaultAnalysisExcel(this.props.matrixs, this.props.machines, customer)
  }

  handleDownloadPDF(customer) {
    downloadFaultAnalysisPDF(this.props.matrixs, this.props.machines, customer)
  }

  openAnalysis(customer) {
    this.setState({ analysisCustomer: customer })
  }

  closeAnalysis() {
    this.setState({ analysisCustomer: null })
  }

  renderFaultList() {
    const { matrixs, machines } = this.props;

    // Create an object to store fault objects by customer name
    const faultsByCustomer = {};

    // Iterate over matrixs and machines to populate faultsByCustomer object
    matrixs.forEach((matrix) => {
      const serial = matrix.Serial;
      const machine = machines.find((machine) => machine.Serial === serial);

      if (machine) {
        const customer = machine.Customer;
        const customerName = customer && customer.Fullname ? customer.Fullname : '';

        matrix.Locker.forEach((lock) => {
          if (lock.FaultCode !== undefined && lock.Status === 'FL') {
            const faultCode = lock.FaultCode;
            const key = customerName;

            if (!faultsByCustomer[key]) {
              faultsByCustomer[key] = {
                customer: customerName,
                BROKEN_LOCK: 0,
                GREEN_BLOCK: 0,
                RED_BLOCK: 0,
                PINPAD_BLOCK: 0,
                DOOR_BLOCK: 0,
                PINPAD_ACTIVE: 0,
                TOTAL_FAULTS: 0,
              };
            }

            faultsByCustomer[key][faultCode]++;
            faultsByCustomer[key].TOTAL_FAULTS++;
          }
        });
      }
    });

    // Convert faultsByCustomer object to an array of fault objects
    const faultList = Object.values(faultsByCustomer);

    // Sort the faultList by customer name in alphabetical order
    faultList.sort((a, b) => a.customer.localeCompare(b.customer));

    const filter = (this.props.filterText || '').trim().toLowerCase();
    const filteredList = filter ? faultList.filter(f => (f.customer || '').toLowerCase().includes(filter)) : faultList;

    return filteredList.map((fault) => (
      <div key={fault.customer} className="list-group-item fault-card d-flex align-items-start justify-content-between">
        <div style={{ flex: 1 }}>
          <div className="font-weight-bold">{fault.customer || '—'}</div>
          <div className="text-muted small">Total: {fault.TOTAL_FAULTS}</div>
          <div className="mt-2 fault-chips" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <span className="badge badge-light">Pinchos: {fault.BROKEN_LOCK}</span>
            <span className="badge badge-light">Pin verde: {fault.GREEN_BLOCK}</span>
            <span className="badge badge-light">Pin rojo: {fault.RED_BLOCK}</span>
            <span className="badge badge-light">Teclado: {fault.PINPAD_BLOCK}</span>
            <span className="badge badge-light">Puerta: {fault.DOOR_BLOCK}</span>
            <span className="badge badge-light">T. encendido: {fault.PINPAD_ACTIVE}</span>
          </div>
        </div>

        <div style={{ marginLeft: 12, display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'stretch', minWidth: 150 }}>
          <span className="badge fault-total-badge" style={{ textAlign: 'center' }}>Total {fault.TOTAL_FAULTS}</span>
          <button
            className="btn btn-sm"
            onClick={() => this.openAnalysis(fault.customer)}
            style={{ background: 'linear-gradient(135deg, #6d28d9, #a855f7)', color: '#fff', border: 'none' }}
          >
            <i className="fas fa-chart-bar mr-1"></i>Análisis
          </button>
          <button
            className="btn btn-sm"
            onClick={() => this.handleDownloadExcel(fault.customer)}
            style={{ background: 'linear-gradient(135deg, #1d6f42, #22a35c)', color: '#fff', border: 'none' }}
          >
            <i className="fas fa-file-excel mr-1"></i>Excel
          </button>
          <button
            className="btn btn-sm"
            onClick={() => this.handleDownloadPDF(fault.customer)}
            style={{ background: 'linear-gradient(135deg, #b91c1c, #ef4444)', color: '#fff', border: 'none' }}
          >
            <i className="fas fa-file-pdf mr-1"></i>PDF
          </button>
        </div>
      </div>
    ));
  }

  render() {
    if (!this.props.matrixs) {
      return null
    }

    return (
      <div id="content-to-pdf">
        <div className="list-group">
          {this.renderFaultList()}
        </div>
        <FaultsAnalysisModal
          open={!!this.state.analysisCustomer}
          customer={this.state.analysisCustomer}
          matrixs={this.props.matrixs}
          machines={this.props.machines}
          onClose={this.closeAnalysis}
        />
      </div>
    )
  }
}

export default connect(null, null)(FaultsByCustomerList);

